import QuestionFieldItem from "pages/ManagementPage/candidateInfoForm/QuestionFieldItem/QuestionFieldItem";

export default QuestionFieldItem;
